import AccessChecker from './AccessChecker';
import rules from './rules';

const accessChecker = new AccessChecker(rules);

export default function isGranted(action: string, ...args: any[]): boolean {
  return accessChecker.isGranted(action, ...args);
}
